export default __webpack_public_path__ + "static/events-dark-a136d1dbe65faac157c35c8bdc72944d.png";